import { Link } from "react-router-dom";
import Toggler from "../../icons/Toggler.svg";
import { Collapse, Dropdown, Nav, Navbar } from "react-bootstrap";
import React, { useState, useContext } from "react";
import dashboardBlack from "../../icons/dashboardBlack.svg";
import masterBlack from "../../icons/MasterBlack.svg";
import transBlack from "../../icons/transBlack.svg";
import reports from "../../icons/report.svg";
import godrejSidebarLogo from "../../icons/godrejSidebar.svg";
import EnquiryBids from "../../icons/Enquirybids.svg"
import { MdLogout } from "react-icons/md";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { ALERT_PARAMS } from "../../utils/constant.js";
import { BsChevronDown } from "react-icons/bs";
import { AuthContext } from "../../contexts/AuthContext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { LOGOUTCONFIRM } from "../../utils/constant";
import { getUserInitials } from "../../utils/Utility";

const SideBar = ({ showSidebar, setShowSidebar }) => {
  const MySwal = withReactContent(Swal);
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [masterMenu, setMenu] = useState(false);
  const [adminMenu, setAdminMenu] = useState(false);
  const [transMenu, setTransMenu] = useState(false);
  const [enquiryMenu, setEnquiryMenu] = useState(false);
  const [reportsMenu, setReportsMenu] = useState(false);
  const context = useContext(AuthContext);
  const initials = getUserInitials(context.userName);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
    setMenu(false);
    setAdminMenu(false);
    setTransMenu(false);
    setEnquiryMenu(false);
    let sidebar1 = !showSidebar;
    //  dispatch(setSideBar(sidebar1));
  };

  function handleLogout() {
    MySwal.fire({
      text: LOGOUTCONFIRM,
      confirmButtonText: "Yes",
      title: "Logout",
      ...ALERT_PARAMS,
    }).then(async (result2) => {
      if (result2.isConfirmed) {
        sessionStorage.removeItem("Token");
        sessionStorage.removeItem("UserData");
        sessionStorage.removeItem("SSOLogin");

        instance.logoutRedirect().catch((e) => {
          console.error(e);
        });
      }
    });
  }

  return (
    <>
      {context.menuName && (
        <div
          id="Sidebar"
          className={showSidebar ? "side-bar open" : "side-bar closed"}
        >
          <div className="sidebar-head">
            {/* <img src={AEM_Logo} alt="AEM Logo" className="head-logo ms-2" /> */}
            <div className="sidebar-logo">
              <span className="head-logo">STMS</span>
              <span className="system-name">
                Scrap Tender Management System
              </span>
            </div>
            <img
              src={Toggler}
              alt="Toggler"
              onClick={toggleSidebar}
              className="head-toggle"
            />
          </div>
          {showSidebar && (
            <div className="sidebar-head-2 d-md-none d-lg-none">
              <div className="user-section">
                <div className="user-logo">
                  <span>{initials}</span>
                </div>
                <div className="user-info">
                  <span className="user-name">{context.userName}</span>
                  <span className="user-email">{context.userEmail}</span>
                </div>
                <MdLogout
                  size={20}
                  color="#707070"
                  onClick={() => {
                    // setShow(true);
                    setShowSidebar(false);
                    handleLogout();
                  }}
                ></MdLogout>
              </div>
            </div>
          )}
          <div className="sidebar-body" id="Sidebar-Body">
            <span className="menu">Menu</span>
            <Nav
              as="ul"
              bsPrefix="nav-list"
              defaultActiveKey={"Dashboard"}
            >
              {context.menuName?.includes("Dashboard") && (
                <Nav.Item as="li" className="list1">
                  <Nav.Link
                    as={Link}
                    to="/"
                    eventKey={"Dashboard"}
                    bsPrefix="nav-list-item"
                    onClick={() => {
                      setShowSidebar(false);
                      setAdminMenu(false);
                      setMenu(false);
                      setTransMenu(false);
                      setEnquiryMenu(false);
                    }}
                  >
                    <div style={{ position: "relative" }}>
                      <img
                        src={dashboardBlack}
                        alt="dashboard"
                        className="sidebar-icon"
                      />
                    </div>
                    <span className="menu-name">Dashboard</span>
                  </Nav.Link>
                </Nav.Item>
              )}

              {context.menuName?.includes("Masters") && (
                <>
                  <Nav.Item
                    as="li"
                    className="list3"
                    onClick={() => {
                      setShowSidebar(true);
                      setMenu(!masterMenu);
                    }}
                  >
                    <Nav.Link eventKey={"Master"} bsPrefix="nav-list-item">
                      <div style={{ position: "relative" }}>
                        <img src={masterBlack} alt="master" className="sidebar-icon" />
                      </div>
                      <span className="menu-name">
                        Masters <BsChevronDown size={15} />
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                  <Collapse in={masterMenu}>
                    <div>
                      <ul className="nav-sub-menu">
                        {context.menuName?.includes("Role & Authorization Master") && (
                          <Nav.Item as="li">
                            <Nav.Link
                              eventKey={"Role & Authorization Master"}
                              as={Link}
                              to="/rolemaster"
                              bsPrefix="sub-menu-item"
                              onClick={() => {
                                setShowSidebar(false);
                                setMenu(!masterMenu);
                              }}
                            >
                              Role & Authorization Master
                            </Nav.Link>
                          </Nav.Item>
                        )}

                        {context.menuName?.includes("User Master") && (
                          <Nav.Item as="li">
                            <Nav.Link
                              eventKey={"User Master"}
                              as={Link}
                              to="/usermaster"
                              bsPrefix="sub-menu-item"
                              onClick={() => {
                                setShowSidebar(false);
                                setAdminMenu(!adminMenu);
                                setMenu(!masterMenu);
                                setTransMenu(false);
                              }}
                            >
                              User Master
                            </Nav.Link>
                          </Nav.Item>
                        )}

                        {context.menuName?.includes("Customer Master") && (
                          <Nav.Item as="li">
                            <Nav.Link
                              eventKey={"Customer Master"}
                              as={Link}
                              to="/customermaster"
                              bsPrefix="sub-menu-item"
                              onClick={() => {
                                setShowSidebar(false);
                                setAdminMenu(!adminMenu);
                                setMenu(!masterMenu);
                                setTransMenu(false);
                              }}
                            >
                              Customer Master
                            </Nav.Link>
                          </Nav.Item>
                        )}

                        {context.menuName?.includes("Item Master") && (
                          <Nav.Item as="li">
                            <Nav.Link
                              eventKey={"Item Master"}
                              as={Link}
                              to="/itemmaster"
                              bsPrefix="sub-menu-item"
                              onClick={() => {
                                setShowSidebar(false);
                                setAdminMenu(!adminMenu);
                                setMenu(!masterMenu);
                                setTransMenu(false);
                              }}
                            >
                              Item Master
                            </Nav.Link>
                          </Nav.Item>
                        )}

                        {context.menuName?.includes("Location Master") && (
                          <Nav.Item as="li">
                            <Nav.Link
                              eventKey={"Location Master"}
                              as={Link}
                              to="/locationmaster"
                              bsPrefix="sub-menu-item"
                              onClick={() => {
                                setShowSidebar(false);
                                setAdminMenu(!adminMenu);
                                setMenu(!masterMenu);
                                setTransMenu(false);
                              }}
                            >
                              Location Master
                            </Nav.Link>
                          </Nav.Item>
                        )}

                        {context.menuName?.includes("Contract Master") && (
                          <Nav.Item as="li">
                            <Nav.Link
                              eventKey={"Contract Master"}
                              as={Link}
                              to="/contractmaster"
                              bsPrefix="sub-menu-item"
                              onClick={() => {
                                setShowSidebar(false);
                                setAdminMenu(!adminMenu);
                                setMenu(!masterMenu);
                                setTransMenu(false);
                              }}
                            >
                              Contract Master
                            </Nav.Link>
                          </Nav.Item>
                        )}
                      </ul>
                    </div>
                  </Collapse>
                </>
              )}

              {context?.menuName?.includes("Disposal Intimation Transaction") && (
                <Nav.Item
                  as="li"
                  className="list3"
                  onClick={() => {
                    setShowSidebar(true);
                    setTransMenu(!transMenu);
                  }}
                >
                  <Nav.Link eventKey={"Disposal Intimation Transaction"} bsPrefix="nav-list-item">
                    <div style={{ position: "relative" }}>
                      <img src={transBlack} alt="disposal intimation transaction" className="sidebar-icon" />
                    </div>
                    <span className="menu-name">
                      Disposal Intimation Transaction <BsChevronDown size={15} />
                    </span>
                  </Nav.Link>
                </Nav.Item>
              )}
              <Collapse in={transMenu}>
                <div>
                  <ul className="nav-sub-menu">
                    {context?.menuName?.includes("Disposal Intimation") && (
                      <Nav.Item as="li">
                        <Nav.Link
                          eventKey={"Disposal Intimation"}
                          as={Link}
                          to="/disposalintimationdashboard"
                          bsPrefix="sub-menu-item"
                          onClick={() => {
                            setShowSidebar(false);
                            setTransMenu(!transMenu);
                            setAdminMenu(false);
                            setMenu(false);
                          }}
                        >
                          Disposal Intimation
                        </Nav.Link>
                      </Nav.Item>
                    )}
                    {context?.menuName?.includes("Disposal Intimation Short Close") && (
                      <Nav.Item as="li">
                        <Nav.Link
                          eventKey={"Disposal Intimation Short Close"}
                          as={Link}
                          to="/disposalintimationshortclose"
                          bsPrefix="sub-menu-item"
                          onClick={() => {
                            setShowSidebar(false);
                            setTransMenu(!transMenu);
                            setAdminMenu(false);
                            setMenu(false);
                          }}
                        >
                          Disposal Intimation Short Close
                        </Nav.Link>
                      </Nav.Item>
                    )}
                  </ul>
                </div>
              </Collapse>

              {context?.menuName?.includes("Enquiries and Bids") && (
                <Nav.Item
                  as="li"
                  className="list3"
                  onClick={() => {
                    setShowSidebar(true);
                    setEnquiryMenu(!enquiryMenu);
                  }}
                >
                  <Nav.Link eventKey={"Enquiries and Bids"} bsPrefix="nav-list-item">
                    <div style={{ position: "relative" }}>
                      <img src={EnquiryBids} alt="enquiries and bids" className="sidebar-icon" />
                    </div>
                    <span className="menu-name">
                      Enquiries and Bids <BsChevronDown size={15} />
                    </span>
                  </Nav.Link>
                </Nav.Item>
              )}
              <Collapse in={enquiryMenu}>
                <div>
                  <ul className="nav-sub-menu">
                    {context?.menuName?.includes("Enquiry/Tender Form") && (
                      <Nav.Item as="li">
                        <Nav.Link
                          eventKey={"Enquiry/Tender Form"}
                          as={Link}
                          to="/enquirydashboard"
                          bsPrefix="sub-menu-item"
                          onClick={() => {
                            setShowSidebar(false);
                            setEnquiryMenu(!enquiryMenu);
                            setAdminMenu(false);
                            setMenu(false);
                            setTransMenu(false);
                          }}
                        >
                          Enquiry/Tender Dashboard
                        </Nav.Link>
                      </Nav.Item>
                    )}
                    {context?.menuName?.includes("Maintain Bid") && (
                      <Nav.Item as="li">
                        <Nav.Link
                          eventKey={"Maintain Bid"}
                          as={Link}
                          to="/maintainbid"
                          bsPrefix="sub-menu-item"
                          onClick={() => {
                            setShowSidebar(false);
                            setEnquiryMenu(!enquiryMenu);
                            setAdminMenu(false);
                            setMenu(false);
                            setTransMenu(false);
                          }}
                        >
                          Maintain Bid
                        </Nav.Link>
                      </Nav.Item>
                    )}
                    {context?.menuName?.includes("Finalize Bid") && (
                      <Nav.Item as="li">
                        <Nav.Link
                          eventKey={"Finalize Bid"}
                          as={Link}
                          to="/finalizebid"
                          bsPrefix="sub-menu-item"
                          onClick={() => {
                            setShowSidebar(false);
                            setEnquiryMenu(!enquiryMenu);
                            setAdminMenu(false);
                            setMenu(false);
                            setTransMenu(false);
                          }}
                        >
                          Finalize Bid
                        </Nav.Link>
                      </Nav.Item>
                    )}
                    {context?.menuName?.includes("Update Sales Order") && (
                      <Nav.Item as="li">
                        <Nav.Link
                          eventKey={"Update Sales Order"}
                          as={Link}
                          to="/update-sales-order"
                          bsPrefix="sub-menu-item"
                          onClick={() => {
                            setShowSidebar(false);
                            setEnquiryMenu(!enquiryMenu);
                            setAdminMenu(false);
                            setMenu(false);
                            setTransMenu(false);
                          }}
                        >
                          Update Sales Order
                        </Nav.Link>
                      </Nav.Item>
                    )}
                  </ul>
                </div>
              </Collapse>

              {context?.menuName?.includes("Reports") && (
                <Nav.Item
                  as="li"
                  className="list3"
                  onClick={() => {
                    setShowSidebar(true);
                    setReportsMenu(!reportsMenu);
                    setAdminMenu(false);
                    setMenu(false);
                    setTransMenu(false);
                  }}
                >
                  <Nav.Link eventKey={"Reports"} bsPrefix="nav-list-item">
                    {/* <RiOrganizationChart size={32} className="menu-icon" /> */}
                    <div style={{ position: "relative" }}>
                      <img src={reports} alt="Reports" className="sidebar-icon" />
                    </div>
                    <span className="menu-name">
                      Reports <BsChevronDown size={15} />
                    </span>
                  </Nav.Link>
                </Nav.Item>
              )}
              <Collapse in={reportsMenu}>
                <div>
                  <ul className="nav-sub-menu">
                    {context?.menuName?.includes("Disposal Intimation Reports") && (
                      <Nav.Item as="li">
                        <Nav.Link
                          eventKey={"Disposal Intimation Reports"}
                          as={Link}
                          to="/disposalintimationreport"
                          bsPrefix="sub-menu-item"
                          onClick={() => {
                            setShowSidebar(false);
                            setReportsMenu(!reportsMenu);
                            setAdminMenu(false);
                            setMenu(false);
                            setTransMenu(false);
                          }}
                        >
                          Disposal Intimation Reports
                        </Nav.Link>
                      </Nav.Item>
                    )}
                    {context?.menuName?.includes("Enquiry/Tender Reports") && (
                      <Nav.Item as="li">
                        <Nav.Link
                          eventKey={"Enquiry/Tender Reports"}
                          as={Link}
                          to="/enquirytenderreport"
                          bsPrefix="sub-menu-item"
                          onClick={() => {
                            setShowSidebar(false);
                            setReportsMenu(!reportsMenu);
                            setAdminMenu(false);
                            setMenu(false);
                            setTransMenu(false);
                          }}
                        >
                          Enquiry/Tender Reports
                        </Nav.Link>
                      </Nav.Item>
                    )}
                    {context?.menuName?.includes("Closed Bids") && (
                      <Nav.Item as="li">
                        <Nav.Link
                          eventKey={"Closed Bids"}
                          as={Link}
                          to="/closedbidsreport"
                          bsPrefix="sub-menu-item"
                          onClick={() => {
                            setShowSidebar(false);
                            setReportsMenu(!reportsMenu);
                            setAdminMenu(false);
                            setMenu(false);
                            setTransMenu(false);
                          }}
                        >
                          Closed Bids
                        </Nav.Link>
                      </Nav.Item>
                    )}
                  </ul>
                </div>
              </Collapse>

            </Nav>
            <div className="sidebar-godrej-logo-div">
              <img
                src={godrejSidebarLogo}
                alt="Godrej Logo"
                className="sidebar-godrej-logo"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SideBar;